import { MessageSender } from '@/survey-graphql';

interface MatrixSubQuestionSource {
  readonly id: string;
  readonly text: string;
  readonly questionOrder?: number | null;
}

interface MatrixQuestionSource {
  readonly id: string;
  readonly notApplicableLabel?: string | null;
  readonly subQuestions?: ReadonlyArray<MatrixSubQuestionSource> | null;
}

interface MatrixMessageSource {
  readonly sender: string;
  readonly questionId: string | null | undefined;
  readonly assistantQuestion: boolean;
}

export interface MessageMatrixFields {
  readonly subQuestions: { id: string; text: string }[] | undefined;
  readonly notApplicableLabel: string | null | undefined;
}

export const NO_MATRIX_FIELDS: MessageMatrixFields = {
  subQuestions: undefined,
  notApplicableLabel: undefined,
};

function isPrimaryAssistantMessage(message: MatrixMessageSource): boolean {
  return (
    message.sender === MessageSender.Assistant && !message.assistantQuestion
  );
}

export function resolveMessageMatrixFields(
  questions: ReadonlyArray<MatrixQuestionSource> | null | undefined,
  message: MatrixMessageSource
): MessageMatrixFields {
  if (!message.questionId || !isPrimaryAssistantMessage(message)) {
    return NO_MATRIX_FIELDS;
  }

  const question = questions?.find((q) => q.id === message.questionId);
  if (!question?.subQuestions?.length) return NO_MATRIX_FIELDS;

  return {
    subQuestions: question.subQuestions
      .toSorted((a, b) => (a.questionOrder ?? 0) - (b.questionOrder ?? 0))
      .map(({ id, text }) => ({ id, text })),
    notApplicableLabel: question.notApplicableLabel,
  };
}
